// types
import { ThemeMode } from 'types/config';
import { PaletteThemeProps } from 'types/theme';
import { HABIHUB_SWITCH_COLORS_BY_THEME } from 'config';

// ==============================|| PRESET THEME - DEFAULT ||============================== //

const Default = (mode: ThemeMode, useV3BrandColors = false): PaletteThemeProps => {
  const contrastText = '#fff';
  const habihubLogoV3BlueColors = [
    '#e8e3ff',
    '#cfc4ff',
    '#b4a2ff',
    '#927aff',
    '#6548ff',
    '#3700ff',
    '#3100e6',
    '#2900c2',
    '#22009e',
    '#1a007a',
    '#130057'
  ];
  const habihubLogoV3PinkColors = [
    '#fbe8f4',
    '#f4c1df',
    '#ed98c9',
    '#e66fb3',
    '#de4fa4',
    '#d43b99',
    '#bf348a',
    '#a82d79',
    '#912668',
    '#791f57',
    '#621846'
  ];
  const habihubLogoV3DarkPinkColors = [
    '#2b1a28',
    '#421d34',
    '#602041',
    '#83264f',
    '#ad2f74',
    '#d43b99',
    '#de63ae',
    '#e78ac4',
    '#efb0d8',
    '#f7d5eb',
    '#fbe8f4'
  ];

  // let primaryColors = ['#E9F0FF', '#C8D9FF', '#A3C0FF', '#7EA6FF', '#6293FF', '#4680FF', '#3F78FF', '#376DFF', '#2F63FF', '#2050FF'];
  let primaryColors = useV3BrandColors
    ? HABIHUB_SWITCH_COLORS_BY_THEME
      ? habihubLogoV3BlueColors
      : habihubLogoV3PinkColors
    : ['#e5a2cc', '#e08fc2', '#db7cb8', '#d569ae', '#d057a4', '#cb449a', '#b73d8b', '#a2367b', '#8e306c', '#7a295c', '#66224d'];
  let secondaryColors = ['#F8F9FA', '#F8F9FA', '#F3F5F7', '#DBE0E5', '#BEC8D0', '#8996A4', '#5B6B79', '#3E4853', '#1D2630', '#131920'];
  // let errorColors = ['#f5bebe', '#e76767', '#dc2626', '#d31c1c', '#c50d0d'];
  // let warningColors = ['#f7dcb3', '#edad4d', '#e58a00', '#de7700', '#d35a00'];
  // let infoColors = ['#c5eff3', '#78d9e2', '#3ec9d6', '#30bccc', '#1ba9bc'];
  // let successColors = ['#c0e5d9', '#6bc2a5', '#2ca87f', '#21976c', '#107d4f'];
  let errorColors = ['#FDE8E7', '#F25E52', '#F04134', '#EE3B2F', '#E92A21'];
  let warningColors = ['#FFF7E0', '#FFC926', '#FFBF00', '#FFB900', '#FFA900'];
  let infoColors = ['#E0F4F5', '#26B0BA', '#00A2AE', '#009AA7', '#008694'];
  let successColors = ['#E0F5EA', '#26B56E', '#00A854', '#00A04D', '#008D3A'];

  if (mode === ThemeMode.DARK) {
    // primaryColors = ['#2050FF', '#2F63FF', '#376DFF', '#3F78FF', '#4680FF', '#6293FF', '#7EA6FF', '#A3C0FF', '#C8D9FF', '#E9F0FF'];
    primaryColors = useV3BrandColors
      ? habihubLogoV3DarkPinkColors
      : ['#e5a2cc', '#e08fc2', '#db7cb8', '#d569ae', '#d057a4', '#cb449a', '#b73d8b', '#a2367b', '#8e306c', '#7a295c', '#66224d'];
    secondaryColors = ['#131920', '#1D2630', '#3E4853', '#5B6B79', '#8996A4', '#BEC8D0', '#DBE0E5', '#F3F5F7', '#F8F9FA', '#F8F9FA'];
    // errorColors = ['#c50d0d', '#d31c1c', '#dc2626', '#e76767', '#f5bebe'];
    // warningColors = ['#d35a00', '#de7700', '#e58a00', '#edad4d', '#f7dcb3'];
    // infoColors = ['#1ba9bc', '#30bccc', '#3ec9d6', '#78d9e2', '#c5eff3'];
    // successColors = ['#107d4f', '#21976c', '#2ca87f', '#6bc2a5', '#c0e5d9'];
    errorColors = ['#321d1d', '#7d2e28', '#d13c31', '#e66859', '#f8baaf'];
    warningColors = ['#342c1a', '#836611', '#dda705', '#e9bf28', '#f8e577'];
    infoColors = ['#1a2628', '#11595f', '#058e98', '#1ea6aa', '#64cfcb'];
    successColors = ['#1a2721', '#115c36', '#05934c', '#1da65d', '#61ca8b'];
  }

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText
    },
    secondary: {
      lighter: secondaryColors[0],
      100: secondaryColors[1],
      200: secondaryColors[2],
      light: secondaryColors[3],
      400: secondaryColors[4],
      500: secondaryColors[5]!,
      main: secondaryColors[6],
      dark: secondaryColors[7],
      800: secondaryColors[8],
      darker: secondaryColors[9],
      contrastText
    },
    error: {
      lighter: errorColors[0],
      light: errorColors[1],
      main: errorColors[2],
      dark: errorColors[3],
      darker: errorColors[4],
      contrastText
    },
    warning: {
      lighter: warningColors[0],
      light: warningColors[1],
      main: warningColors[2],
      dark: warningColors[3],
      darker: warningColors[4],
      contrastText
    },
    info: {
      lighter: infoColors[0],
      light: infoColors[1],
      main: infoColors[2],
      dark: infoColors[3],
      darker: infoColors[4],
      contrastText
    },
    success: {
      lighter: successColors[0],
      light: successColors[1],
      main: successColors[2],
      dark: successColors[3],
      darker: successColors[4],
      contrastText
    }
  };
};

export default Default;
